<template>
<div>
  <w-obj-rsc-key-select-component v-show="!hiddenSelectCmp" :class="hiddenSelectCmp ? null : 'mr-b10'" :rsc-info-list="rscInfoList" @select="setRscInfo" @reset="reset" />
  <w-performance-predict-component :rsc-info="rscInfo" />
</div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import WObjRscKeySelectComponent from './components/ObjRscKeySelectComponent';
import WPerformancePredictComponent from './components/PerformancePredictComponent';

export default {
  name: 'WPerformancePredictView',
  components: {
    WObjRscKeySelectComponent,
    WPerformancePredictComponent,
  },
  props: {
    rscInfoList: {
      type: Array,
    },
  },
  data() {
    return {
      rscInfo: null,
    };
  },
  computed: {
    hiddenSelectCmp() {
      return this.rscInfoList.length === 1;
    },
  },
  methods: {
    isEmpty,
    setRscInfo(rscInfo) {
      this.rscInfo = rscInfo;
    },
    reset() {
      this.rscInfo = null;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/popup/ResourceSmartAnalyzerPopup/PerformancePredictView.vue